// l10n status: done
//import { Button } from "@mui/material"
import { CreateComponent } from "components/utils/CreateComponent.js"
import React, { useRef } from "react"
import { RecordingsManager } from "scenes/Recordings/components/RecordingsManager"
import { RECORDING_OPTIONS } from "store/page/recordings/RecordingsManager"
import { rootStore } from "store/RootStore"
import { computed } from "mobx"
import { ButtonRecord, ButtonDelete, ButtonCancel, ButtonMore, ButtonRecordSeries, ButtonVisibility, ButtonArchive, ButtonInfo, ButtonSwitchProfile } from "scenes/components/ButtonComponents"
import { moment } from "store/util/moment"
import { l10n } from "store/lang/L10n"
import { eventId, season, episode, isSeries, channelId, startTs, endTs } from "utils/EventHelpers"
import { appFeatures } from "AppFeatures"

export const RecordingButtons = CreateComponent(null, false, true, ({ oEvent, origin, buttonAdd, buttonRemove, buttonsCommit }) => {
	// MTVW-518: use computed to reflect changes in recordings events
	const eventManager = computed(() => rootStore.page.Recordings.Manager.getRecordingEvent(oEvent)).get()
	//const marker = computed(() => rootStore.page.Recordings.Manager.getMarker(oEvent?.id)).get()
	const marker = rootStore.page.Recordings.Manager.getMarker(eventId(oEvent))
	const buttons = eventManager.buttonsLists

	console.info("eventManager=%o buttons=%o buttons=%o", eventManager, buttons, Object.keys(buttons))

	const managerRef = useRef()
	if (marker) console.debug("RecordingButtons= Season %o, Episode %o isSeries %o evtMngr %o buttons %o marker %o",
		season(oEvent), episode(oEvent), isSeries(oEvent), eventManager, buttons, marker)

	// GT12: MTVW-500, MTVW-460, MTVW-502: Channels MS flags
	const buttonsEnabled = computed(() => rootStore.page.MsEpg?.isRecordingAllowed(channelId(oEvent), startTs(oEvent), endTs(oEvent))
		// MTVW-820: marker condition for standalone recording out of epg window to enable more button
		|| marker !== null).get()
	//const buttonsEnabled = true
	//console.debug("conditions", rootStore.page.MsEpg?.isRecordingAllowed(channelId(oEvent), startTs(oEvent), endTs(oEvent)), buttonsEnabled)
	//console.debug("RecordingButtons single %s, series %s, planned %s", eventManager.isRecordedAsSingle, eventManager.isRecordedAsSeries)

	const isProfileOwner = marker?.ProfileId === rootStore?.sso?.profile?.id

	/* no recording yet */
	if ((buttons[RECORDING_OPTIONS.series_episode_record] ||
		buttons[RECORDING_OPTIONS.series_record]) && buttonsEnabled && appFeatures.traxisAvailable) {
		buttonAdd(ButtonRecord, {
			bId: `buttonRecord_${origin}`, label: l10n.commonActionRecord, // Aufnehmen
			onClick: () => void managerRef?.current?.setTypeRecording(Object.keys(buttons)), dataTest: "record"
		})
	}
	else buttonRemove(`buttonRecord_${origin}`)

	/* no series only one episode */
	if (buttons[RECORDING_OPTIONS.episode_record] && buttonsEnabled && appFeatures.traxisAvailable) {
		buttonAdd(ButtonRecord, {
			bId: `buttonRecordEpisode_${origin}`, label: l10n.commonActionRecord, // "Aufnehmen"
			onClick: () => void managerRef?.current?.setTypeRecording([RECORDING_OPTIONS.episode_record]), dataTest: "record"
		})
	}
	else buttonRemove(`buttonRecordEpisode_${origin}`)

	let buttonMore = null
	if (buttons[RECORDING_OPTIONS.episode_cancel] && isProfileOwner) {
		buttonAdd(ButtonCancel, {
			bId: `buttonCancelEpisode_${origin}`, label: l10n.dialogCancelRecordingAction, // "Aufnahme abbrechen"
			onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.episode_cancel), dataTest: "abbrechen"
		})
		if (!buttons[RECORDING_OPTIONS.series_record_add] && buttonsEnabled) {
			buttonMore = {
				// no specific button in modal, set to null
				contentMore: [{
					bType: null, props: null
				},
				{
					bType: null, props: null
				}]
			}
		}
	}
	else buttonRemove(`buttonCancelEpisode_${origin}`)

	if (buttons[RECORDING_OPTIONS.episode_delete] && isProfileOwner) {
		buttonAdd(ButtonDelete, {
			bId: `buttonDeleteEpisode_${origin}`, label: l10n.dialogDeleteRecordingAction, // "Aufnahme löschen"
			onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.episode_delete), dataTest: "loschen"
		})
		if (!buttons[RECORDING_OPTIONS.series_record_add] && buttonsEnabled) {
			buttonMore = {
				// no specific button in modal, set to null
				contentMore: [{
					bType: null, props: null
				},
				{
					bType: null, props: null
				}]
			}
		}
	}
	else buttonRemove(`buttonDeleteEpisode_${origin}`)

	if (buttons[RECORDING_OPTIONS.series_episode_cancel] && isProfileOwner) {
		buttonAdd(ButtonCancel, {
			bId: `buttonCancelSeriesEpisode_${origin}`, label: l10n.dialogCancelRecordingAction, // "Aufnahme abbrechen"
			onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_episode_cancel), dataTest: "abbrechen"
		})
		if (!buttons[RECORDING_OPTIONS.series_record_add] && buttonsEnabled) {
			buttonMore = {
				// no specific button in modal, set to null
				contentMore: [{
					bType: null, props: null
				},
				{
					bType: null, props: null
				}]
			}
		}
	}
	else buttonRemove(`buttonCancelSeriesEpisode_${origin}`)

	if (buttons[RECORDING_OPTIONS.series_episode_delete] && isProfileOwner) {
		buttonAdd(ButtonDelete, {
			bId: `buttonDeleteSeriesEpisode_${origin}`, label: l10n.dialogDeleteSingleRecordingAction, // "Einzelaufnahme löschen"
			onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_episode_delete), dataTest: "loschen"
		})
	}
	else buttonRemove(`buttonDeleteSeriesEpisode_${origin}`)

	if (buttons[RECORDING_OPTIONS.series_delete] && buttons[RECORDING_OPTIONS.series_cancel] && isProfileOwner) {
		buttonMore = {
			contentMore: [{
				bType: ButtonDelete, props: {
					//inModal: true,
					bId: `buttonDeleteSeries_${origin}`, label: l10n.dialogDeleteSeriesRecordingAction, // "Serienaufnahme löschen"
					onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_delete), dataTest: "serienaufnahme_loschen"
				}
			},
			{
				bType: ButtonCancel, props: {
					//inModal: true,
					bId: `buttonCancelSeries_${origin}`, label: l10n.dialogCancelSeriesRecordingAction, // "Serienaufnahme abbrechen"
					onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_cancel), dataTest: "serienaufnahme_abbrechen"
				}
			}]
		}
	}
	else {
		if (buttons[RECORDING_OPTIONS.series_delete] && isProfileOwner) {
			/*
			buttonAdd(ButtonDelete, {
				bId: `buttonDeleteSeries_${origin}`, label: l10n.dialogDeleteSeriesRecordingAction, // "Serienaufnahme löschen"
				onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_delete), dataTest: "serienaufnahme_loschen"
			})
			*/
			buttonMore = {
				contentMore: [{
					bType: ButtonDelete, props: {
						//inModal: true,
						bId: `buttonDeleteSeries_${origin}`, label: l10n.dialogDeleteSeriesRecordingAction, // "Serienaufnahme löschen"
						onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_delete)//, dataTest: "serienaufnahme_loschen"
					}
				},
				{
					bType: null, props: null
				}]
			}
		}
		else buttonRemove(`buttonDeleteSeries_${origin}`)

		if (buttons[RECORDING_OPTIONS.series_cancel] && isProfileOwner) {
			/*
			buttonAdd(ButtonCancel, {
				bId: `buttonCancelSeries_${origin}`, label: l10n.dialogCancelSeriesRecordingAction, // "Serienaufnahme abbrechen"
				onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_cancel), dataTest: "serienaufnahme_abbrechen"
			})
			*/
			buttonMore = {
				contentMore: [{
					bType: ButtonCancel, props: {
						//inModal: true,
						bId: `buttonCancelSeries_${origin}`, label: l10n.dialogCancelSeriesRecordingAction, // "Serienaufnahme abbrechen"
						onClick: () => void managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.series_cancel), dataTest: "serienaufnahme_abbrechen"
					}
				},
				{
					bType: null, props: null
				}]
			}
		}
		else buttonRemove(`buttonCancelSeries_${origin}`)
	}

	/* only an episode is alredy recorded of a series, and this start record all series*/
	if (buttons[RECORDING_OPTIONS.series_record_add] && buttonsEnabled && isProfileOwner) {
		/*
		buttonAdd(ButtonRecord, {
			bId: `buttonRecordSeries_${origin}`, label: l10n.dialogStartSeriesRecordingAction, // "Serienaufnahme starten"
			onClick: () => void managerRef?.current?.setTypeRecording([RECORDING_OPTIONS.series_record_add]), dataTest: "record"
		})
		*/
		buttonMore = {
			contentMore: [{
				bType: ButtonRecordSeries, props: {
					//inModal: true,
					bId: `buttonRecordSeries_${origin}`, label: season(oEvent) ? l10n.dialogRecordSeasonNumberLabel.format(season(oEvent)) : l10n.dialogRecordSeriesLabel,//l10n.dialogStartSeriesRecordingAction
					onClick: () => void managerRef?.current?.setTypeRecording([RECORDING_OPTIONS.series_record_add]), dataTest: "record"
				}
			},
			{
				bType: null, props: null
			}]
		}
	}
	else {
		console.debug("button changed", buttons)
	}

	if (!isProfileOwner && marker) {
		buttonMore = null
		const buttonInfo = {
			contentMore: [{
				bType: ButtonSwitchProfile, props: {
					//inModal: true,
					bId: `buttonSwitchProfile_${origin}`, label: l10n.commonActionSwitchProfile,
					onClick: () => {
						//rootStore.page.Player.player.stopInstance()
						// make sure that movie poster is displayed
						rootStore.page.OverlayEventDetails.setIsPlayerPresent(false)
						rootStore.sso.handleChangeProfile(marker?.ProfileId, false)
					}, dataTest: "switch_profile"
				}
			},
			{
				bType: null, props: null
			}]
		}
		buttonAdd(ButtonInfo, {
			bId: `buttonInfo_${origin}`, label: l10n.dialogSharedRecordingTitle, ...{ buttonInfo },
			onClick: () => managerRef?.current?.setTypeInfo(buttonInfo.contentMore)
		})
	}

	if (buttonMore) {
		// visibility and archive buttons at the beginning
		//const onAcceptHandler = managerRef?.current?.onAcceptHandler
		//console.debug("onAcceptHandler", onAcceptHandler)

		// If the program is still within the recording window, the “Remove from archive” removes the program
		// from the archive and closes the modal.If the program is no longer within the recording window,
		// the “Unarchive and delete modal” is displayed
		let isInRecordingWindow = true
		if (marker?.State === "Complete") {
			const safetyMargin = 3600000 // 1hour
			isInRecordingWindow = moment(marker?.AvailabilityEnd).utc().valueOf() - safetyMargin > moment().utc().valueOf()
			console.debug("isInRecordingWindow", isInRecordingWindow, marker?.AvailabilityEnd, moment(marker?.AvailabilityEnd).utc().valueOf(), moment().utc().format("YYYY-MM-DDTHH:mm:ssZ"), moment().utc().valueOf())
		}
		// archive flag can only be set by the owner
		// Define the items conditionally
		const itemsToAdd = [
			// Item 1: Visibility Toggle
			...(!rootStore.channelsService?.isAdultChannel(oEvent?.channel?.id) ? [{
				bType: ButtonVisibility,
				props: {
					bId: `buttonVisibility`,
					variant: "secondary",
					label: marker?.IsPersonal ? l10n.dialogRecordInAllProfilesLabel : l10n.dialogRecordOnlyInThisProfileLabel,
					onClick: function () {
						// no snackbarText, immediately handled with setTargetMarker
						return managerRef?.current?.onAcceptHandler({ callbackName: "handleVisibilityToggle"/*, snackbarText: "Sichtbarkeit wird geändert"*/ })
					},
					dataTest: "visibility"
				}
			}] : []),
			// Item 2: Archive Toggle
			...(marker?.State === "Complete" ? [{
				bType: ButtonArchive,
				props: {
					bId: `buttonArchive`,
					variant: "secondary",
					label: !marker?.IsDeleteProtected 
					? (isSeries(oEvent) ? l10n.dialogArchiveEpisodeRecordingAction : l10n.dialogArchiveRecordingAction) 
					: l10n.dialogRemoveRecordingFromArchiveAction,
					onClick: function () {
						return isInRecordingWindow || !marker?.IsDeleteProtected 
						// no snackbarText, immediately handled with setTargetMarker
						? managerRef?.current?.onAcceptHandler({ callbackName: "handleArchiveToggle" })
						: managerRef?.current?.setTypeDelete(RECORDING_OPTIONS.archive_remove)
					},
					dataTest: "archive"
				}
			}] : [])
		]

		// 2. Add them to the start of the array only if there's something to add
		if (itemsToAdd.length > 0) {
			buttonMore.contentMore.unshift(...itemsToAdd)
			if (buttonMore.contentMore.length > 0) {
				buttonAdd(ButtonMore, {
					bId: `buttonMore_${origin}`, label: l10n.featureDetailsRecordingButtonMoreOptions, ...buttonMore,
					onClick: () => managerRef?.current?.setTypeMore(buttonMore.contentMore)
				})
			}
		}
	}
	else buttonRemove(`buttonMore_${origin}`)
	buttonsCommit("RecordingButtons")

	return (
		<RecordingsManager ref={managerRef} oEvent={oEvent} />
	)
})
